import {CALL_API} from 'redux/middleware/api'
import {
  SITES,
  SITE_ADD,
  SITE_EDIT,
  SITE_DELETE
} from './'
import {reportError} from 'redux/modules/error/actions'
import {showToast} from 'redux/modules/ui/toaster/actions'
import {getCurrentMerchant} from '../currentUser/selectors'

export function fetchSites() {
  return {
    [CALL_API]: {
      endpoint: `sites`,
      errorsHandled: true,
      types: SITES
    }
  }
}

export function addSite({merchantId, url, currency, industry, timezone, platform, source}) {
  return (dispatch, getState) => {
    const state = getState()
    const {id} = getCurrentMerchant(state)
    return dispatch({
      [CALL_API]: {
        endpoint: `merchants/${id}/sites`,
        errorsHandled: true,
        method: 'POST',
        types: SITE_ADD,
        body: {name: url, url, currency, industry, timezone, platform, tags: {'creation_​source': source || 'app'}}
      }
    })
      .success(site => {
        dispatch(fetchSites())
        const merchant = getCurrentMerchant(getState())
        return {site, merchant}
      })
      .fail(dispatch(reportError()))
  }
}

export function deleteSite(siteId) {
  return dispatch => dispatch({
    [CALL_API]: {
      endpoint: `sites/${siteId}`,
      errorsHandled: true,
      method: 'DELETE',
      types: SITE_DELETE
    }
  })
    .success(() => dispatch(fetchSites()))
    .success(() => dispatch(showToast(`Site successfully deleted`)))
    .fail(() => dispatch(reportError()))
}

export function editSite({name, url, currency, timezone, id, platform}) {
  return (dispatch, getState) => dispatch({
    [CALL_API]: {
      endpoint: `sites/${id}`,
      errorsHandled: true,
      method: 'PATCH',
      types: SITE_EDIT,
      body: {name, url, currency, timezone, platform}
    }
  })
    .success(site => {
      dispatch(fetchSites())
      const merchant = getCurrentMerchant(getState())
      return {site, merchant}
    })
    .fail(() => dispatch(reportError()))
}

export function editSiteInternalWhitelistRegexes({internalWhitelistRegexes, id}) {
  return (dispatch, getState) => dispatch({
    [CALL_API]: {
      endpoint: `sites/${id}`,
      errorsHandled: true,
      method: 'PATCH',
      types: SITE_EDIT,
      body: {internalWhitelistRegexes}
    }
  })
    .success(site => {
      dispatch(fetchSites())
      const merchant = getCurrentMerchant(getState())
      return {site, merchant}
    })
    .fail(() => dispatch(reportError()))
}

export function editCountryLimitList({countriesLimit, id}) {
  return (dispatch, getState) => dispatch({
    [CALL_API]: {
      endpoint: `sites/${id}`,
      errorsHandled: true,
      method: 'PATCH',
      types: SITE_EDIT,
      body: {countriesLimit}
    }
  })
    .success(site => {
      dispatch(fetchSites())
      const merchant = getCurrentMerchant(getState())
      return {site, merchant}
    })
    .fail(() => dispatch(reportError()))
}

export function editCampainField({campaignField, id}) {
  return (dispatch, getState) => dispatch({
    [CALL_API]: {
      endpoint: `sites/${id}`,
      errorsHandled: true,
      method: 'PATCH',
      types: SITE_EDIT,
      body: {campaignField}
    }
  })
    .success(site => {
      dispatch(fetchSites())
      const merchant = getCurrentMerchant(getState())
      return {site, merchant}
    })
    .success(() => dispatch(showToast(`Successfully Updated`)))
    .fail(() => dispatch(reportError()))
}



// WEBPACK FOOTER //
// ./client/redux/modules/sites/actions.js